import { FC, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { ItiLink as Link } from 'components';
import { useAuth } from 'contexts';
import { SelectedLocationContext } from 'contexts/selected-location';
import { useOutsideClickHandler } from 'hooks';
import { Role } from 'types';
import './app-bar.scss';

const cmcLogo = require('assets/images/CMC_Logo.png');

const GateAppBar: FC = () => {
  const navigate = useNavigate();
  const { selectedLocation } = useContext(SelectedLocationContext);
  const { userProfile } = useAuth();

  const username = localStorage.getItem('username');
  const menuRef = useRef<HTMLDivElement>(null);
  useOutsideClickHandler(menuRef, div => div?.classList.remove('active'));

  return (
    <header id="gate-app-bar" className="d-flex justify-content-between overflow-x-hidden w-100 p-2">
      <div className="h-100 d-flex g-3">
        <img alt="logo" className="h-100" src={cmcLogo} />
        <div className="h-100 d-flex flex-column justify-content-evenly nowrap">
          <h4 className="text-secondary font-weight-medium m-0">{username}</h4>
          {!!selectedLocation && <h5 className="text-info-main font-weight-medium m-0">{selectedLocation.name}</h5>}
        </div>
      </div>
      <div className="dropdown-menu flex-shrink-0">
          <button
            className="btn-back h-100 p-4"
            onClick={e => {
              e.stopPropagation();
              menuRef.current?.classList.toggle('active');
            }}
          >
            <span className="material-icons icon-large">menu</span>
          </button>
          <div className="menu-list grid-big-1 m-1 p-3" ref={menuRef}>
            <Link to="/gate" className="d-flex g-3">
              <span className="material-icons">home</span>
              Gate Access
            </Link>
            <Link to="/gate/pending" className="d-flex g-3 nowrap">
              <span className="material-icons">pending</span>
              Pending Drafts
            </Link>
            <Link to="/gate/complete" className="d-flex g-3 nowrap">
              <span className="material-icons">schedule</span>
              Recent Transactions
            </Link>
            <Link to="/gate/units" className="d-flex g-3 nowrap">
              <span className="material-icons">grid_view</span>
              Yard Management
            </Link>
            {[Role.ADMIN, Role.BILLING_ADMIN, Role.SENIOR_BOOKING, Role.BOOKING].includes(userProfile.role) && (
              <Link to="/dashboard" className="d-flex g-3 nowrap">
                <span className="material-icons">dashboard</span>
                Customer Portal
              </Link>
            )}
            {/* the dashboard is closed to this role; bookings is the portal page it works in */}
            {userProfile.role === Role.GATE_BOOKING && (
              <Link to="/bookings" className="d-flex g-3 nowrap">
                <span className="material-icons">collections_bookmark</span>
                Customer Portal
              </Link>
            )}
            <button className="a btn-back d-flex g-3 nowrap" onClick={() => navigate('/logout')}>
              <span className="material-icons">logout</span>
              Logout
            </button>
          </div>
        </div>
    </header>
  );
};

export default GateAppBar;
